// live.ts — the poll tick behind the overview pane's "Live" switch.
//
// Feeds are written while a training job runs, so a pane opened mid-run has
// to re-ask for them. Polling is paused while the tab is hidden — a
// backgrounded dashboard asking every few seconds for hours is pure load on
// both ends — and fires once on the way back so returning to the tab never
// shows a stale chart.
import { useEffect, useState } from 'react';

export const LIVE_INTERVAL_MS = 10_000;

// The repo page re-reads its experiments, graph and dirty marks this often,
// so a page left open keeps up with CI without a reload.
export const PAGE_REFRESH_MS = 60_000;

export function useLiveTick(enabled: boolean, intervalMs = LIVE_INTERVAL_MS): number {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    if (!enabled) return;
    const timer = window.setInterval(() => {
      if (!document.hidden) setTick((t) => t + 1);
    }, intervalMs);
    const onVisibility = () => {
      if (!document.hidden) setTick((t) => t + 1);
    };
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [enabled, intervalMs]);
  return tick;
}
